import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import Person4OutlinedIcon from '@mui/icons-material/Person4Outlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';


export default function Sidebar() {
  const theme = useTheme();

  //Dynamically add menu
  const links = [
    { text: "Home", icon: <HomeOutlinedIcon />, href: "#top" },
    { text: "Work", icon: <WorkOutlineOutlinedIcon />, href: "#work" },
    { text: "Blog", icon: <EventNoteOutlinedIcon />, href: "https://hashnode.com/@joshwrites" },
    { text: "About", icon: <Person4OutlinedIcon />, href: "/link4" },
    { text: "Contact", icon: <EmailOutlinedIcon />, href: "#contact" },
  ];
  return (
    <>
      <Box
        sx={{
          height: "100%",
          width: "250px",
          position: "fixed",
          zIndex: 1,
          top: 0,
          left: 0,
          overflowX: "hidden",
          borderRight: "1px solid rgb(41, 41, 41)",
          textAlign: "left",
        }}
        className="custom-sidebar"
      >
        <Box
          sx={{ borderBottom: "1px solid rgb(41, 41, 41)", padding: "36px" }}
        >
          <Typography
            variant="h3"
            className="user"
            sx={{
              color: theme.palette.common.white,
              fontSize: "22px",
              fontWeight: 250,
            }}
          >
            Joshua Chivile
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "rgb(128, 128, 128)",
              fontSize: "16px",
              fontWeight: 200,
              marginTop: "10px",
            }}
          >
            Software Engineer
          </Typography>
        </Box>
        {links.map((link, index) => (
          <Box
            key={index}
            className="sidebar-icons"
            sx={{
              borderBottom: "1px solid rgb(41, 41, 41)",
              padding: "23px 36px",
              display: "flex",
              alignItems: "center",
              cursor: "pointer"
            }}
          >
            {link.icon}
            <a href={link.href}>{link.text}</a>
          </Box>
        ))}
      </Box>
    </>
  );
}
